import { Injectable } from '@angular/core';
import { Http, Headers , RequestOptions } from '@angular/http';
import { ToastController, AlertController, Events } from 'ionic-angular';
import { AuthServiceProvider } from '../auth-service/auth-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

/*
  Generated class for the MovimientocarteraServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MovimientocarteraServiceProvider {

  serverServicios = "";
  headers = new Headers();
  headersPost:any;
  constructor(public http: Http, public toastCtrl : ToastController, public events: Events,
    public alertCtrl : AlertController, public autorizacionService: AuthServiceProvider) {
    
    //this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";

    this.headers.append('Authorization', this.autorizacionService.token);

    this.headersPost = new Headers({ 'Content-Type': 'application/json' });
    this.headersPost.append('Authorization', this.autorizacionService.token);
  }

  get(idtmovcar, id) {
    return this.http.get(this.serverServicios + '/pospago/list/1/'+ idtmovcar + '/' + id, {headers: this.headers})
      .map(res => res.json()).catch(err => this.events.publish('user:validartoken', err._body));
  }

  getFecha(identidad, desde, hasta) {
    return this.http.get(this.serverServicios + '/pospago/listfecha/1/'+ identidad + '/' + desde + '/' + hasta, {headers: this.headers})
      .map(res => res.json()).catch(err => this.events.publish('user:validartoken', err._body));
  }

  getCarteras(identidad, iddepartamento) {
    var cadena = this.serverServicios + '/poscartera/deudas/1/'+ identidad + '/' + iddepartamento+ '/1/1';
    //console.log(cadena)
    return this.http.get(cadena, {headers: this.headers})
    	.map(res => res.json()).catch(err => this.events.publish('user:validartoken', err._body));
  }

  getDocumentoTesoreria(idtmovcar) {
    return this.http.get(this.serverServicios + '/pospago/tdoctes/1/'+idtmovcar, {headers: this.headers})
    	.map(res => res.json()).catch(err => this.events.publish('user:validartoken', err._body));
  }

  getCuentas(idtdoctes) {
    return this.http.get(this.serverServicios + '/pospago/cuenta/1/' + idtdoctes, {headers: this.headers})
    	.map(res => res.json()).catch(err => this.events.publish('user:validartoken', err._body));
  }

  guardar(movcar){

    return new Promise((resolve, reject) => {
	    this.http.post(this.serverServicios + '/pospago', JSON.stringify(movcar), {headers: this.headersPost}).toPromise().then((response) => {
	      console.log('API Response : ', response.json());
	      this.toastCtrl.create({
	        message: 'Movimiento almacenado correctamente!',
	        duration: 3000,
	        position: 'bottom'
	      }).present();
	      resolve(response.json());
	    }).catch((err) =>{
        this.events.publish('user:validartoken', err._body);
	      console.error('API Error : ', err.status);
	      console.error('API Error : ', JSON.stringify(err));
	    });
	  });
  }

  eliminar(idmovcar){

    this.get(0, idmovcar).subscribe(val => {
      val.idestado=1;
      for (var i = 0; i < val.detalle.length; i++) {
        val.detalle[i].idestado = 1;
      }
      for (var j = 0; j < val.detalleTesoreria.length; j++) {
        val.detalleTesoreria[j].idestado = 1;
      }
      this.guardar(val);
    });
  }

  enviarcomprobante(data){
    return new Promise((resolve, reject) => {
      this.http.post( this.serverServicios + '/poscorreo/comprobante', JSON.stringify(data), {headers: this.headersPost}).subscribe(res => {
          resolve(res);
        }, (err) => {
          this.events.publish('user:validartoken', err._body);
          reject(err);
        });
    });

  }

  getReporte(idempresa,idmovcar)
  {
    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/pospdf/comprobante/'+idempresa+'/'+idmovcar, {headers: this.headers}).subscribe(data => {
      resolve(data.json());
      }, err => {
        this.events.publish('user:validartoken', err._body);
      console.log(err);
      });
    }); 
    
  }
}



// WEBPACK FOOTER //
// ./src/providers/movimientocartera-service/movimientocartera-service.ts